export enum PermissionSubject {
  Organismes = 'organismes',
  Interlocuteurs = 'interlocuteurs',
  Interactions = 'interactions',
  AccessRights = 'accessRights',
  All = 'all',
}
